import { render } from "./Header.vue?vue&type=template&id=7000aeec&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=7000aeec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7000aeec"

export default script
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QBtnDropdown,QList,QItem,QItemSection,QBtn});qInstall(script, 'directives', {ClosePopup});
